/**
 * @summary Contains the slider thumbnails list preact component.
 */

import { h, Component } from 'preact';
import SliderThumbsThumb from './SliderThumbsThumb';
import InView from '../in-view';

/**
 * @summary Slider thumbnails list preact component.
 */
export default class SliderThumbs extends Component {
	constructor( props ) {
		super( props );

		this.setThumb = this.setThumb.bind( this );

		this.thumbElements = [];
	}

	/**
	 * @summary Sets reference to a thumbnail DOM element.
	 *
	 * @param {HTMLElement} element The DOM element.
	 * @param {number} index The index key of the thumbnail.
	 */
	setThumb( element, index ) {
		this.thumbElements[index] = element;
	}

	componentDidMount() {
		new InView( this.thumbElements, 0.2, this.inviewLoad );
	}

	render({ data, activeIndex, handleClick }) {
		const thumbs = data.map( item => (
			<SliderThumbsThumb
				key={item.index}
				{...item}
				active={activeIndex === item.index}
				handleClick={handleClick}
				onRef={this.setThumb}
			/>
		) );

		return (
			<ul class="l-grid l-grid--300 l-grid--rigid l-grid--products">{thumbs}</ul>
		);
	}
};



// WEBPACK FOOTER //
// ./src/js/components/SliderThumbs.js